module.exports = __webpack_public_path__ + "img/backImg.e39312df.jpg";